<div class="flex justify-center items-center h-screen">
      <p-progressSpinner />
      <p>Connecting to tool...</p>
</div>